import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from 'vue';
import { computed, toRefs, ref } from '@nuxtjs/composition-api';
import type { Props as ErrorWithButtonProps } from '~/core/components/composed/placeholder/ErrorWithButton.vue';
import type { AsyncComponentLoader } from 'vue/types/v3-define-async-component';
import CenteredAffility from '../loader/CenteredAffility.vue';
// import type { Props as LoaderProps }

interface Props {
    componentLoader: AsyncComponentLoader;
    asyncComponentConfig?: { delay: number, timeout: number };
    errorWithButtonProps?: ErrorWithButtonProps;
    componentProps?: Record<string | number | symbol, unknown>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AsyncWithLoadingAndError',
  props: {
    componentLoader: null,
    asyncComponentConfig: { default: () => ({ delay: 200, timeout: 5000 }) },
    errorWithButtonProps: null,
    componentProps: null
  },
  setup(__props: any) {

const props = __props as { componentLoader: AsyncComponentLoader, asyncComponentConfig: { delay: number, timeout: number }, errorWithButtonProps?: ErrorWithButtonProps, componentProps?: Record<string | number | symbol, unknown> };



const {
    asyncComponentConfig,
    componentLoader,
    errorWithButtonProps,
    componentProps,
} = toRefs(props);

const isErrored = ref(null);
const retryFunc = ref(null);

const asyncComponent = computed(() => {
    return defineAsyncComponent({
        loader: componentLoader.value,
        loadingComponent: CenteredAffility,
        delay: asyncComponentConfig.value.delay || 200,
        timeout: asyncComponentConfig.value.timeout || 3000,
        onError(error, retry, fail, attempts) {
            console.warn(`Attempt N${attempts}. Error when loading async component`, error);
            isErrored.value = !!error;
            retryFunc.value = retry;
        },
    });
});

const retryInternal = () => {
    isErrored.value = false;
    if (retryFunc.value) retryFunc.value();
    retryFunc.value = null;
};



return { __sfc: true,props, asyncComponentConfig, componentLoader, errorWithButtonProps, componentProps, isErrored, retryFunc, asyncComponent, retryInternal }
}

})